import { Resource as i, API as a } from "@coveo/platform-client";
const e = class e extends i {
  list(t, s = {}) {
    return this.api.get(
      this.buildPath(e.baseUrl, { ...s, trackingId: t })
    );
  }
  create(t) {
    return this.api.post(e.baseUrl, t);
  }
  delete(t) {
    return this.api.delete(`${e.baseUrl}/${t}`);
  }
  get(t) {
    return this.api.get(`${e.baseUrl}/${t}`);
  }
  update(t, s) {
    return this.api.put(`${e.baseUrl}/${t}`, s);
  }
  getSlotSettings(t) {
    return this.api.get(`${e.baseUrl}/${t}/settings`);
  }
  updateSlotSettings(t, s) {
    return this.api.put(`${e.baseUrl}/${t}/settings`, s);
  }
  /**
   * Shows the available strategies to use for this slot in an organization.
   * @param configurationId
   * @returns SlotStrategiesModel
   */
  getSlotStrategies(t) {
    return this.api.get(`${e.baseUrl}/${t}/strategies`);
  }
  /**
   * Retrieve strategies available for a slot type and seed type.
   * @param slotType
   * @param seedType
   */
  getStrategies(t, s) {
    return this.api.get(
      this.buildPath(`${e.baseUrl}/strategies`, { slotType: t, seedType: s })
    );
  }
  /**
   * Retrieve all slot configuration ids and names of an organization.
   * @param model SlotsNamesOptions
   * @returns PageModel<SlotConfigurationNameModel>
   */
  listNames(t) {
    return this.api.get(
      this.buildPath(`${e.baseUrl}/names`, t)
    );
  }
};
e.baseUrl = `/rest/organizations/${a.orgPlaceholder}/commerce/v2/recommendations/slots`;
let r = e;
export {
  r as SlotConfiguration
};
//# sourceMappingURL=SlotConfiguration.js.map
